<template>
  <div
    ref="codeElement"
    class="code"
    :class="`language-${lang}`"
  >
    <code :class="`language-${lang}`">
      {{ code }}
    </code>
  </div>
</template>

<script>
// import 'highlight.js/styles/default.css';
// import 'highlight.js/styles/atom-one-dark.css';
// import 'highlight.js/styles/github.css';
import hljs from 'highlight.js';


export default {
  components: {
  },
  props: {
    lang: {
      type: String,
      default: 'javascript',
    },
    code: {
      type: String,
      default: `// 对象拷贝
function copyObject(orig) {
  var copy = Object.create(Object.getPrototypeOf(orig));
  copyOwnPropertiesFrom(copy, orig);
  return copy;
}`,
    },
  },
  data() {
    return {};
  },
  computed: {
    // isDarkMode() {
    //   return this.$vuetify.theme.dark;
    // },
  },
  mounted() {
    // 使用对应的语言进行高亮
    hljs.highlightElement(this.$refs.codeElement);
  },
};
</script>

<style scoped>
/* 根据自己的需要在样式中添加代码高亮主题样式 */
div.code {
  white-space: pre;
  border-radius: 0.3rem;
  padding: 1rem;
}

</style>
